import { Component, OnInit, computed, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ForgeCardModule } from "@tylertech/forge-angular";
import { MetadataViewComponent, MetadataViewService, RepositoryFormData } from "@tylertech/metadata-module";
import { IViewMetadata } from "@tylertech/tyler-api-types";
import { DashboardMetadataService } from "../../services";

@Component({
    selector: "dashboard-metadata",
    imports: [
        FormsModule,
        ForgeCardModule,
        MetadataViewComponent,
    ],
    templateUrl: "./dashboardMetadata.tmpl.html",
})
export class DashboardMetadataComponent implements OnInit
{
    private readonly $metadataViewService = inject(MetadataViewService);
    private readonly $dashboardMetadataService = inject(DashboardMetadataService);


    readonly view = signal<IViewMetadata | undefined>(undefined);

    readonly datacontroller = computed(() =>
    {
        const typeName = this.$metadataViewService.GetTypeName(this.view());
        return new RepositoryFormData(typeName, null);
    });

    readonly loaded = computed(() =>
    {
        return !!this.view();
    });

    ngOnInit(): void
    {
        this.$dashboardMetadataService.GetDashboardMetadataView()
            .then(r =>
            {
                if (!r)
                {
                    return;
                }

                this.view.set(r);
            });
    }
}
